import { IGameEnvModel } from '../../../model/api-modules/env';
import { getLocalGameFilterByGame } from '../game-filter/lib';

export const getCurrentDefaultEnvID = (
  gameID: string,
  envs: ReadonlyArray<IGameEnvModel>
) => {
  if (!envs.length) {
    return 0;
  }
  const localEnvID = getLocalGameFilterByGame(gameID);
  const envItem = envs.find((item) => item.id === localEnvID);
  return envItem?.id || envs[0].id;
};

export const isVersionGreaterThan = (
  versionStr: string,
  targetVersion = '1.12.0'
) => {
  // 不存在版本信息代表没开通过服务 算作新版本
  if (!versionStr) {
    return true;
  }
  // 1. 去掉可能的 'v' 前缀，并去除前后空格
  const cleanVersion = versionStr.trim().replace(/^v/i, '').replace(/-.*$/, '');

  // 2. 检查格式是否合法
  if (!/^\d+(\.\d+)+$/.test(cleanVersion)) {
    return false;
  }

  // 3. 拆分版本号为数字数组，例如 "1.12.0" → [1, 12, 0]
  const currentVersionParts = cleanVersion.split('.').map(Number);
  const targetVersionParts = targetVersion.split('.').map(Number);

  // 4. 比较每一位数字
  const maxLength = Math.max(
    currentVersionParts.length,
    targetVersionParts.length
  );

  for (let i = 0; i < maxLength; i++) {
    const current = currentVersionParts[i] || 0; // 如果某一位不存在，默认为 0
    const target = targetVersionParts[i] || 0;

    if (current > target) {
      return true; // 当前版本某一位更大，整体更大
    }
    if (current < target) {
      return false; // 当前版本某一位更小，整体更小
    }
    // 如果相等，继续比较下一位
  }

  // 所有位都相等
  return true;
};
